export const NO_MATCHES = "No matches"
export const SELECT_VISIBLE = "Select visible"
export const DESELECT_VISIBLE = "Deselect visible"